import { render, staticRenderFns } from "./SharePageSocials.vue?vue&type=template&id=14406611"
import script from "./SharePageSocials.vue?vue&type=script&lang=js"
export * from "./SharePageSocials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconLinkedin: require('/home/userapp/components/Atom/Icon/IconLinkedin.vue').default,ButtonIcon: require('/home/userapp/components/Molecule/Button/ButtonIcon.vue').default,IconFacebook: require('/home/userapp/components/Atom/Icon/IconFacebook.vue').default})
